import { Box, Button, Typography } from '@mui/material';
import { FC, ReactNode, useEffect } from 'react';
import { useTranslations } from 'use-intl';

import CasaLogo from '../../shared/logo/CasaLogo';
import styles from './ErrorScreen.module.scss';

interface ErrorScreenProps {
  icon: ReactNode;
  title: string;
  description: string;
  documentTitle: string;
  onRetry?: () => void;
  onLogout?: () => void;
}

const ErrorScreen: FC<ErrorScreenProps> = ({
  icon,
  title,
  description,
  documentTitle,
  onRetry,
  onLogout,
}) => {
  const t = useTranslations('errors');

  useEffect(() => {
    window.document.title = `${documentTitle} - CASA Retail AI`;
  }, [documentTitle]);

  return (
    <Box id={styles.errorScreen}>
      <Box className={styles.errorScreenHeader}>
        <CasaLogo width={100} height={40} />
      </Box>
      <Box className={styles.errorScreenBody}>
        <Box className={styles.errorScreenIcon}>{icon}</Box>
        <Typography variant='h5'>{title}</Typography>
        <Typography color='secondary' className={styles.errorScreenDescription}>
          {description}
        </Typography>
        {onRetry && (
          <Button
            variant='text'
            className={styles.errorScreenAction}
            onClick={onRetry}
          >
            {t('tryAgain')}
          </Button>
        )}
        {onLogout && (
          <Button
            variant='text'
            color='error'
            className={styles.errorScreenAction}
            onClick={onLogout}
          >
            {t('signOut')}
          </Button>
        )}
      </Box>
    </Box>
  );
};
export default ErrorScreen;
